import React from "react";

const CopilotLogo = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 23.3 512.1 465.4"
        >
            <radialGradient
                id="a"
                cx="-79.674"
                cy="645.551"
                r="11.637"
                gradientTransform="matrix(-10.9605 -13.3892 -12.5901 10.3064 7673.291 -7504.614)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".096" style={{stopColor:"#00aeff"}} />
                <stop offset=".773" style={{stopColor:"#2253ce"}} />
                <stop offset="1" style={{stopColor:"#0736c4"}} />
            </radialGradient>
            <path
                d="M374 62c-6.7-22.9-27.8-38.7-51.7-38.7h-15.7c-26 0-48.3 18.6-53 44.2l-26.9 146.8 6.7-22.9c6.7-23 27.8-38.8 51.7-38.8h91.4l38.3 14.9 36.9-14.9H441c-23.9 0-45-15.8-51.7-38.7z"
                style={{fill:"url(#a)"}}
            />
            <radialGradient
                id="b"
                cx="-20.581"
                cy="641.788"
                r="11.637"
                gradientTransform="matrix(9.8803 12.5737 12.1968 -9.5842 -7518.271 6768.395)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" style={{stopColor:"#ffb657"}} />
                <stop offset=".634" style={{stopColor:"#ff5f3d"}} />
                <stop offset=".923" style={{stopColor:"#c02b3c"}} />
            </radialGradient>
            <path
                d="M143.5 449.8c6.7 23 27.8 38.9 51.8 38.9h33.4c29.2 0 53.1-23.3 53.9-52.5l3.6-141.5-7.6 26c-6.7 23-27.8 38.7-51.7 38.7h-92.2l-32.9-17.8-35.6 17.8h10.6c24 0 45.1 15.9 51.8 38.9z"
                style={{fill:"url(#b)"}}
            />
            <linearGradient
                id="c"
                x1="151.476"
                x2="178.106"
                y1="452.543"
                y2="144.451"
                gradientTransform="matrix(1 0 0 -1 0 514)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".156" style={{stopColor:"#0d91e1"}} />
                <stop offset=".487" style={{stopColor:"#52b471"}} />
                <stop offset=".652" style={{stopColor:"#98bd42"}} />
                <stop offset=".937" style={{stopColor:"#ffc800"}} />
            </linearGradient>
            <path
                d="M320 23.3H133.4C80 23.3 48 93.7 26.7 164.2 1.4 247.7-31.6 359.4 64 359.4h80.6c24.1 0 45.2-15.9 51.8-39.1 14-49 38.6-134.5 57.9-199.6 9.8-33.1 18-61.5 30.5-79.2 7.1-9.9 18.8-18.2 35.2-18.2"
                style={{fill:"url(#c)"}}
            />
            <linearGradient
                id="d"
                x1="154.129"
                x2="168.669"
                y1="491.116"
                y2="155.012"
                gradientTransform="matrix(1 0 0 -1 0 514)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" style={{stopColor:"#3dcbff"}} />
                <stop offset=".247" style={{stopColor:"#0588f7", stopOpacity:0}} />
            </linearGradient>
            <path
                d="M320 23.3H133.4C80 23.3 48 93.7 26.7 164.2 1.4 247.7-31.6 359.4 64 359.4h80.6c24.1 0 45.2-15.9 51.8-39.1 14-49 38.6-134.5 57.9-199.6 9.8-33.1 18-61.5 30.5-79.2 7.1-9.9 18.8-18.2 35.2-18.2"
                style={{fill:"url(#d)"}}
            />
            <radialGradient
                id="e"
                cx="-46.943"
                cy="664.318"
                r="11.637"
                gradientTransform="matrix(-12.6711 36.2357 43.4092 15.1796 -28974.764 -8263.428)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".066" style={{stopColor:"#8c48ff"}} />
                <stop offset=".5" style={{stopColor:"#f2598a"}} />
                <stop offset=".896" style={{stopColor:"#ffb152"}} />
            </radialGradient>
            <path
                d="M192 488.7h186.7c53.3 0 85.3-70.5 106.7-141 25.3-83.5 58.3-195.2-37.3-195.2h-80.6c-24.1 0-45.2 15.9-51.8 39.1-14 49-38.6 134.6-57.9 199.7-9.8 33.1-18 61.5-30.5 79.2-7.2 9.9-18.9 18.2-35.3 18.2"
                style={{fill:"url(#e)"}}
            />
            <linearGradient
                id="f"
                x1="352.459"
                x2="352.268"
                y1="382.231"
                y2="290.663"
                gradientTransform="matrix(1 0 0 -1 0 514)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset=".058" style={{stopColor:"#f8adfa"}} />
                <stop offset=".708" style={{stopColor:"#a86edd", stopOpacity:0}} />
            </linearGradient>
            <path
                d="M192 488.7h186.7c53.3 0 85.3-70.5 106.7-141 25.3-83.5 58.3-195.2-37.3-195.2h-80.6c-24.1 0-45.2 15.9-51.8 39.1-14 49-38.6 134.6-57.9 199.7-9.8 33.1-18 61.5-30.5 79.2-7.2 9.9-18.9 18.2-35.3 18.2"
                style={{fill:"url(#f)"}}
            />
        </svg>
    );
};

export default CopilotLogo;
